export default "__VITE_ASSET__52d8a6d9__"